import { ConfigService } from '@services/webFeeder/config.service';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { Constants } from '@utils/constants';
import { AuthenticationService } from '@services/authentication.service';
import { Signature } from '@model/signature.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-update-signature',
  templateUrl: './update-signature.component.html'
})
export class UpdateSignatureComponent implements OnInit {
  model: Signature = new Signature();
  errorMsg01: string = Constants.MSG01_SIGNATURE_ERROR;
  dialog: MatDialog;
  validSignature = true;
  loadingReset: boolean;
  loadingForgot: boolean;
  showSignature = false;
  showNewSignature = false;
  showConfirmSignature = false;
  isForgot = false;
  titleUpdate = 'Nova assinatura eletrônica';
  subTitleUpdate = 'Para definir uma nova assinatura eletrônica, será necessário informar a sua assinatura eletrônica atual.';
  showConfirmForgot = false;
  titleForgot = 'Recuperar assinatura eletrônica';
  subTitleSignature = 'Uma mensagem com uma nova assinatura eletrônica vai ser enviada para e-mail cadastrado.';
  showConfirmReset = false;
  email: string;
  showError = false;
  titleError = Constants.MSG01_FORGOT_SIGNATURE_TITLE_ERROR;
  contentError = Constants.MSG01_FORGOT_SIGNATURE_CONTENT_ERROR;
  helpPhone1: any;
  helpEmail: string = '';

  constructor(
    public dialogRef: MatDialogRef<UpdateSignatureComponent>,
    public _notificationService: NotificationsService,
    private _authenticationService: AuthenticationService,
    private _configService: ConfigService,
    dialog: MatDialog,
  ) {
    this.dialog = dialog;
  }

  ngOnInit() {
    this.model.signature = '';
    this.model.newSignature = '';
    this.model.confirmSignature = '';
    this.showSignature = false;
    this.showNewSignature = false;
    this.showConfirmSignature = false;
    this.isForgot = false;
    this.showConfirmForgot = false;
    this.showConfirmReset = false;
    this.email = this._configService.getHbEmail();
    this.getContact();
  }

  getContact() {
    const organization = Constants.WHITELABEL.find(org => org.system.cod == environment.WHITELABEL)
    this.helpPhone1 = organization.contact.supportPhone;
    this.helpEmail = organization.contact.email;
  }

  closeClick(): void {
    this.dialogRef.close();
  }

  toggleSignature() {
    this.showSignature = !this.showSignature;
  }

  toggleNewSignature() {
    this.showNewSignature = !this.showNewSignature;
  }

  toggleConfirmSignature() {
    this.showConfirmSignature = !this.showConfirmSignature;
  }

  validatorSignature(value) {
    if (this.model.newSignature !== this.model.confirmSignature) {
      this.validSignature = false;
    } else {
      this.validSignature = true;
    }
  }

  validChar(e) {
    const isNumber = new RegExp('^[0-9]+$');
    if (!(isNumber.exec(e.key))) {
      return false;
    }
  }

  changeSignature() {
    this.loadingReset = true;
    this.loadingForgot = false;
    if (this.model.signature === this.model.newSignature) {
      this._notificationService.warn('', Constants.MSG02_SIGNATURE_ERROR);
      this.loadingReset = false;
      return;
    }
    this._authenticationService.resetSignature(this.model.signature, this.model.newSignature)
      .subscribe(res => {
        if (res && (res.success === 'true' || res.success === true)) {
          this.model = new Signature();
          this.showConfirmReset = true;
        } else {
          if (res && res.message) {
            this._notificationService.error('', res.message);
          } else {
            this._notificationService.error('', Constants.MSG_LOGIN_MSG003);
          }
          this.showError = true;
        }
        this.model = new Signature();
        this.loadingReset = false;
      }, error => {
        this._notificationService.error('', Constants.MSG_LOGIN_MSG003);
        this.showError = true;
        this.loadingReset = false;
      });
  }

  forgotSignature() {
    this.isForgot = !this.isForgot;
  }

  sendForgotSignature() {
    this.loadingForgot = true;
    this.loadingReset = false;
    if (!this.email) {
      this._notificationService.warn('', Constants.MSG04_SIGNATURE_ERROR);
      this.loadingForgot = false;
      return;
    }
    this._authenticationService.forgotSignature(this.email)
      .subscribe(res => {
        if (res && (res.success === 'true' || res.success === true)) {
          this.model = new Signature();
          this.showConfirmForgot = true;
        } else if (res && !res.error && res.data && res.data.status >= 200) {
          this.model = new Signature();
          this.showConfirmForgot = true;
        } else {
          if (res && res.message) {
            this._notificationService.error('', res.message);
          } else {
            this._notificationService.error('', Constants.MSG_LOGIN_MSG003);
          }
          this.showError = true;
        }
        this.loadingForgot = false;
      }, error => {
        this._notificationService.error('', Constants.MSG_LOGIN_MSG003);
        this.showError = true;
        this.loadingForgot = false;
      });
  }

  goBack() {
    if (this.showError) {
      this.showError = false;
    } else if (!this.showConfirmReset && !this.showConfirmForgot) {
      this.isForgot = !this.isForgot;
    } else {
      this.showConfirmReset = false;
      this.showConfirmForgot = false;
    }
    this.loadingReset = false;
    this.loadingForgot = false;
  }

  openWhatsappWindow() {
    if (this.helpPhone1.isWhatsApp) {
      window.open(Constants.SIDEBAR_HELP_WHATSAPP_LINK + this.helpPhone1.phoneNumber);
    }
  }

}
